var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useRef } from 'react';
import { Tooltip } from '@hn-ui/tooltips';
import { styled } from 'styled-components';
import { DashIcon } from '../../images/icons';
var Container = styled.div.withConfig({ displayName: "Container", componentId: "sc-1gj2ecp" })(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n"], ["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n"])));
var ScDashIcon = styled(DashIcon).withConfig({ displayName: "ScDashIcon", componentId: "sc-1oq30uw" })(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  margin-right: 2px;\n\n  & path {\n    fill: ", ";\n  }\n"], ["\n  margin-right: 2px;\n\n  & path {\n    fill: ", ";\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.black80;
});
var GreenText = styled.p.withConfig({ displayName: "GreenText", componentId: "sc-1y69tqo" })(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  color: ", ";\n"], ["\n  color: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.green30;
});
var RedText = styled.p.withConfig({ displayName: "RedText", componentId: "sc-1uryvqh" })(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  color: ", ";\n"], ["\n  color: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.red40;
});
var BlackText = styled.p.withConfig({ displayName: "BlackText", componentId: "sc-qtlo" })(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  color: ", ";\n"], ["\n  color: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.black10;
});
var TooltipContainer = styled.div.withConfig({ displayName: "TooltipContainer", componentId: "sc-ecdupa" })(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  display: flex;\n  flex-flow: column;\n  font-size: 13px;\n"], ["\n  display: flex;\n  flex-flow: column;\n  font-size: 13px;\n"])));
var Header = styled.h2.withConfig({ displayName: "Header", componentId: "sc-iy1wgr" })(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  margin: 0 0 8px 0;\n  font-size: inherit;\n"], ["\n  margin: 0 0 8px 0;\n  font-size: inherit;\n"])));
var GrowthValue = styled.div.withConfig({ displayName: "GrowthValue", componentId: "sc-1fp4tzz" })(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n  display: flex;\n  align-items: baseline;\n  white-space: nowrap;\n  font-size: inherit;\n"], ["\n  display: flex;\n  align-items: baseline;\n  white-space: nowrap;\n  font-size: inherit;\n"])));
var GrowthTooltip = function (_a) {
    var value = _a.value, children = _a.children;
    var ref = useRef(null);
    var growthText = value === 0
        ? "no growth since Placement Test"
        : "equal to " + Math.abs(value) / 100 + " grade level " + (value > 0 ? 'growth' : 'regression');
    return (_jsx(Tooltip, __assign({ content: _jsxs(TooltipContainer, __assign({ ref: ref }, { children: [_jsx(Header, { children: "Growth" }, void 0), _jsx(GrowthValue, { children: growthText }, void 0)] }), void 0), maxWidth: 'none', mountNode: ref.current || undefined }, { children: children }), void 0));
};
var GrowthResult = function (_a) {
    var value = _a.value, rest = __rest(_a, ["value"]);
    var getStyledGrowthResult = function () {
        if (value < 0) {
            return _jsx(RedText, { children: value }, void 0);
        }
        if (value > 0) {
            return _jsxs(GreenText, { children: ["+", value] }, void 0);
        }
        return _jsx(BlackText, { children: value }, void 0);
    };
    return _jsx(Container, __assign({}, rest, { children: getStyledGrowthResult() }), void 0);
};
var Growth = function (_a) {
    var value = _a.value, rest = __rest(_a, ["value"]);
    var hasValue = value !== undefined && value !== null;
    if (!hasValue) {
        return _jsx(ScDashIcon, { "aria-label": 'dash' }, void 0);
    }
    return (_jsx(GrowthTooltip, __assign({ value: value }, { children: _jsx(GrowthResult, __assign({ value: value }, rest), void 0) }), void 0));
};
export { Growth };
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8;
